export class PwPoint {

    constructor(json: any) {
        if (json) {
            Object.assign(this, json);
        }
    }

    lat: number;
    lng: number;
}
